define((require) => {
    "use strict";

    const EditorContextMenu = require("ui/editor/EditorContextMenu");
    const ExperiencesEditor = require("ui/editor/ExperiencesEditor");
    const ImprovedView      = require("editor/zbone/ImprovedView");
    const Permissions       = require("shared/security/Permissions");
    const template          = require("ui/editor/EditorView.tpl");
    const WidgetToolboxView = require("ui/experience/widgets/WidgetToolboxView");
    const WidgetTypes       = require("shared/ui/experience/widgets/WidgetTypes");
    const {Logger}          = require("shared/util/Logger");
    const EditorWebFontController  = require("editor/ui/experience/editor/EditorWebFontController");

    const logger = new Logger("EditorView");

    /**
     * An editor view that supports editing multiple experiences.
     *
     * @class EditorView
     * @author Kim
     */
    return ImprovedView.extend({

        className: "editor-view pt-page",

        template,

        _contextMenu: null,

        _cursorWidgetType: null,

        $body: null,

        transitions: {
            "in": "pt-page-scaleUp",
            out: "pt-page-scaleDown"
        },

        regions: {
            widgetToolbox: ".widget-toolbox",
            editorsRegion: ".editor-region"
        },

        events: {
            /**
             * Listening on the general drag event(text or anything draggable) within editor so that
             * we don't show the unwanted Drop hotspot area.
             *
             * @see how the drop hotspot area is applied in {@Link DropAreaHotspot}
             */
            "dragstart": "_dragStartHandler",
            "dragend": "_dragEndHandler",
            "click": "_widgetTypeClearedHandler"
        },

        experiencesEditor: null,

        initialize() {
            EditorWebFontController.start();
            this._contextMenu = new EditorContextMenu(this);
        },

        onTransitionedIn() {
            this.viewScope.viewModel.trigger("editorView:TransitionedIn");
        },

        /**
         * Add class internal-drag so we know that the drag is initiated within the editor page,
         * This is to tell apart from the drags outside the page, for example files.
         * @private
         */
        _dragStartHandler() {
            this.$body.addClass("internal-drag");
        },

        _dragEndHandler() {
            this.$body.removeClass("internal-drag");
        },

        _widgetTypeSelectedHandler(widgetType, icon) {
            this._cursorWidgetType = widgetType;
            this.$body.addClass("cursor-" + icon);
        },

        _widgetTypeClearedHandler(event) {
            // When the widget is either created or user cancels,
            // remove any 'cursor-***' classes added to the body
            // to return the cursor to default pointer.
            if (!event || !event.target.classList.contains("cursor-loading-widget")) {
                this._cursorWidgetType = null;
                this.$body.removeClass((index, classNames) => {
                    return classNames.split(/\s+/).filter((className) => {
                        return className.includes("cursor-");
                    }).join(" ");
                });
            }
        },

        /**
         * The viewScope is the backbone of editor view, it is auto inherited to all its subviews.
         *
         * @returns {{inherit: boolean, viewModel: *, getExperienceSize: Function}}
         */
        viewScope() {
            return {
                inherit: false,

                viewModel: this.model,

                spectatorMode: Permissions.Privileges.CREATE.cannot(),

                clearCursorWidgetType() {
                    this._widgetTypeClearedHandler();
                },

                getCursorWidgetType() {
                    return this._cursorWidgetType;
                },

                setCursorWidgetType(widgetType, icon) {
                    if (!WidgetTypes.lookup(widgetType)) {
                        logger.warn("Invalid widget type: " + widgetType);
                    } else {
                        this._widgetTypeSelectedHandler(widgetType, icon);
                    }
                },

                getExperienceSize() {
                    return this.model.get("experience").getSize();
                },

                // Returns the viewport element
                getViewportElement() {
                    return this.experiencesEditor.getViewportElement();
                },

                getCurrentSceneBounds() {
                    var element = this.$(".scene-editor.current"),
                        offset = element.offset();

                    return {
                        top: offset.top,
                        left: offset.left,
                        width: element.width(),
                        height: element.height()
                    };
                },

                getSceneBounds(sceneID) {
                    var element = this.$(".scene-editor." + sceneID),
                        offset = element.offset();

                    return {
                        top: offset.top,
                        left: offset.left,
                        width: element.width(),
                        height: element.height()
                    };
                }
            };
        },

        /**
         * When the editor view is in DOM, show all regions
         */
        onShow() {
            const {
                project,
                groups,
                prototypeWidgetCollection
            } = this.options;

            this.$body = this.$el.parents("body");
            this.experiencesEditor = new ExperiencesEditor({
                model: this.model,
                project,
                groups
            });

            this.editorsRegion.show(this.experiencesEditor);

            this.widgetToolbox.show(new WidgetToolboxView({
                model: this.model,
                prototypeWidgetCollection
            }));

            /* when user clicks on a widget, which goes beyond the canvas,
            ".editor-region" element (because it contains "overflow: hidden") is scrolled
            and changes its "scrollTop" property. To avoid this behavior (especially in Safari)
            we need to overwrite ".editor-region" onscroll function */
            this.editorsRegion.$el[0].onscroll = function() {
                this.scrollTo(0, 0);
            };
        },

        onClose() {
            this._contextMenu.close();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/EditorView.js